import {HTTP} from './http'
import moment from 'moment'

//发送邮件验证码
//@param action {register 为注册用验证码 ；find_password 为找回密码用验证码}
export const apiSendEmailCaptcha = async (action,account) => {
    let res = await HTTP(`/user/sendEmailCaptcha/${action}`,"post",{account})
    return res
}

//@param action {register 为注册用验证码 ；find_password 为找回密码用验证码}
export const apiSendSmsCaptcha = async (action,account) => {
    let res = await HTTP(`/user/sendSmsCaptcha/${action}`,"post",{account})
    return res
}

//注册
export const apiRegister = async (data) => {
    let res = await HTTP(`/user/register`,"post",data)
    return res
}

//重制密码
export const apiResetPassword = async (data) => {
    let res = await HTTP(`/user/reSetPassport`,"post",data)
    return res
} 

//登录
export const apiLogin = async (data) => {
    let res = await HTTP(`/api/login`,"post",data)
    return res
}

//刷新token
export const apiRushToken = async () => {
    let res = await HTTP(`/user/rushToken`,"get")
    return res
}

//获取登录的用户信息
export const apiGetUserInfo = async () => {
    let res = await HTTP(`/user/me`,"get")
    return res
}

//获取生效的赛制列表
export const apiGetRounds = async () => {
    let res = await HTTP(`/user/getRoundList`,"get")
    if(res.code === 200){
        for(let item of res.data){
            for(let process of item.processes){
                process.start_t = moment(process.start_t).valueOf();
                process.end_t = moment(process.end_t).valueOf();
            }
        }
    }
    return res
}

//获取地区
export const apiGetCity = async (area_id) => {
    let res = await HTTP(`/api/common/getCity`,"get",{area_id})
    return res
}


//获取OSS参数
export const apiGetOssConfig = async () => {
    let res = await HTTP(`/user/getConfig`,"get")
    return res
}

/************** 报名begin **************/

//获取提交的报名信息
export const apiGetReportTeamData = async (round_id) => {
    let res = await HTTP(`/user/getReportTeamData`,"get",{round_id})
    return res
}

//提交报名信息（个人赛）
export const apiSetReportTeamDataPersonal = async (round_id,memberData,teamData) => {
    let res = await HTTP(`/user/setReportTeamData/personal`,"post",{round_id,memberData,teamData})
    return res
}

//提交报名信息（团队赛）
export const apiSetReportTeamDataTeam = async (round_id,teamData,memberData,teacherData) => {
    let res = await HTTP(`/user/setReportTeamData/team`,"post",{round_id,teamData,memberData,teacherData})
    return res
}

/************** 报名end **************/

/************** 流程处理begin **************/


//提交流程
export const apiSetProcess = async (round_id,label,data={}) => {
    let res = await HTTP(`/user/setProcess`,"post",{round_id,label,data})
    return res
}

//获取单条历史提交流程
export const apiGetProcess = async (round_id,label) => {
    let res = await HTTP(`/user/getProcess`,"get",{round_id,label})
    return res
}

//获取提交的文件
export const apiGetFileInfo = async (file_id) => {
    let res = await HTTP(`/user/getFileInfo`,"get",{file_id})
    return res
}

//获取提交的文件
export const apiUploadFileInfo = async (data) => {
    let res = await HTTP(`/user/upload`,"post",data)
    return res
}

//获取提交的文件
export const apiSSO = async (data) => {
    let res = await HTTP(`/user/login/sso`,"get",data)
    return res
}

//获取提交的文件
export const apiSSORegister = async (data) => {
    let res = await HTTP(`/user/login/sso/signup`,"get",data)
    return res
}

//获取提交的文件
export const apiSSOAuth = async (data) => {
    let res = await HTTP(`/user/login/sso`,"post",data)
    return res
}

//退出
export const apiLogut = async (data) => {
    let res = await HTTP(`/user/login/out`,"post",data)
    return res
}


//获取单赛制历史流程
export const apiGetProcesses = async (round_id) => {
    let res = await HTTP(`/user/getProcesses`,"get",{round_id})
    // if(res.code === 200){
    //     for(let item of res.data){
    //         // item.
    //     }
    // }
    return res
}

// 获取学校
export const apiGetProvinceUniversity = async () => {
    let res = await HTTP(`/user/province_university`,"get")
    return res
}
// 提交学校信息
export const apiSubSchoolInfo = async (data) => {
    let res = await HTTP(`/user/team_school`,"post",data)
    return res
}
// 获取提交的学校信息
export const apiGetSubSchoolInfo = async (round_id) => {
    let res = await HTTP(`/user/team_school`,"get",{round_id})
    return res
}

// 提交个人注册信息
export const apiSubPersonalInfo = async (data) => {
    let res = await HTTP(`/user/person`,"post",data)
    return res
}

// 获取提交的个人注册信息
export const apiGetSubPersonalInfo = async () => {
    let res = await HTTP(`/user/person`,"get")
    return res
}

// 获取支付链接
export const apiGetPayLink = async () => {
    let res = await HTTP(`/user/person/pay`,"post")
    return res
}

// 查询支付状态
export const apiGetPayStatus = async (order_sn) => {
    let res = await HTTP(`/user/person/order/${order_sn}`,"get")
    return res
}

// 答题链接
export const apiGetAnswerLink = async () => {
    let res = await HTTP(`/user/person/person_question_link`,"get")
    return res
}

// 查询城市字典
export const apiGetCities = async () => {
    let res = await HTTP(`/user/cities`,"get")
    return res
}

// 查询半决赛提交信息
export const apiGetSemiFinalInfo = async () => {
    let res = await HTTP('/user/final',"get")
    return res
}

// 提交半决赛信息
export const apiSubSemiFinalInfo = async (data) => {
    let res = await HTTP('/user/final',"post",data)
    return res
}


/************** 流程处理end **************/




